













import CPasswordInput from '~/components/shared/configurable/form/input/CPasswordInput.vue'
import { computed, defineComponent, ref, toRefs } from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { Ref } from '@vue/composition-api'
import { formFieldProps } from '~/constants/form'
import { useDep } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import { useI18n } from '~/compositions/i18n'

export default defineComponent({
  components: { CPasswordInput, FieldError },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = toRefs(props)

    const value = ref<any>(null)
    const passwordIsHashed = ref(false)

    function onValue(v: Ref<string>) {
      if (v.value === '<hashed>') {
        value.value = ''
        passwordIsHashed.value = true
      } else {
        value.value = v.value
        passwordIsHashed.value = false
      }
    }

    const { error, debouncedValueChanged, isValid } = useClassifiedForm(props, {
      onValue
    })
    const { t } = useI18n()

    const formValidationBuilder = useDep(FormValidationBuilder)

    const placeholder = computed(() =>
      passwordIsHashed.value
        ? t('your previous password is used')
        : t('enter a password')
    )
    const autocomplete = computed(() =>
      passwordIsHashed.value ? 'current-password' : 'new-password'
    )

    const options = computed(() => {
      return specs.value?.values || []
    })

    const handlePasswordInput = (password: string) => {
      formValidationBuilder
        .new(error)
        .minChars(specs.value?.min, password, true)
        .maxChars(specs.value?.max, password)
        .validate()
      debouncedValueChanged(name.value, value.value)
    }

    return {
      passwordIsHashed,
      placeholder,
      options,
      value,
      error,
      handlePasswordInput,
      isValid,
      autocomplete
    }
  }
})
